import Glide from '@glidejs/glide'
( function( $ ) {

	var borgarmonOffcanvas = document.getElementById('navbarNavOffcanvas');
	borgarmonOffcanvas.addEventListener('show.bs.offcanvas', function () {
		$('.navbar-borgarmon .navbar-toggler').removeClass('collapsed');
	})
	borgarmonOffcanvas.addEventListener('hide.bs.offcanvas', function () {
		$('.navbar-borgarmon .navbar-toggler').addClass('collapsed');
	})

	$(document).scroll(function() {
		var y = $(this).scrollTop();
		if (y > 220) {
			$('.navbar-borgarmon').addClass( 'hide-element' );
		} else {
			$('.navbar-borgarmon').removeClass( 'hide-element' );
		}
	});

	$(window).load( function()
	{
		/*if ( document.getElementsByClassName('news-slider').length > 0 )
		{
			const swiper = new Swiper('.swiper', {
			  // Optional parameters
			  direction: 'horizontal',
			  loop: false,
			  slidesPerView: 2.6,
			  spaceBetween: 40,
			  threshold: 2,
			  cssMode: false,
			  breakpoints: {
				320: {
					slidesPerView: 1,
				},
				767: {
					slidesPerView: 1.4,
				},
				1200: {
					slidesPerView: 2.6,
				},
				1500: {
					slidesPerView: 3,
				}
			  },
			  });
		}*/
		if ( document.getElementsByClassName('process-slider').length > 0 )
		{
			var processSlider = new Glide('.process-slider', {
				type: 'carousel',
				//startAt: 0,
				perView: 1,
				gap: 40,
				autoplay: false,
				animationDuration: 1000,
				animationTimingFunc: 'ease-in-out',
				/*peek: {
					before: 100,
					after: 100,
				},*/
				/*breakpoints: {
					991: {
						perView: 1,
						peek: {
							before: 70,
							after: 70,
						},
					},
					575: {
						gap: 5,
						perView: 1,
						peek: {
							before: 45,
							after: 45,
						}
					}
				}*/
			}).mount()
		}
		if ( document.getElementsByClassName('testimonial-slider').length > 0 )
		{
			var processSlider = new Glide('.testimonial-slider', {
				type: 'carousel',
				//startAt: 0,
				perView: 1,
				gap: 40,
				autoplay: false,
				animationDuration: 1000,
				animationTimingFunc: 'ease-in-out',
				/*peek: {
					before: 100,
					after: 100,
				},*/
				/*breakpoints: {
					991: {
						perView: 1,
						peek: {
							before: 70,
							after: 70,
						},
					},
					575: {
						gap: 5,
						perView: 1,
						peek: {
							before: 45,
							after: 45,
						}
					}
				}*/
			}).mount()
		}
	});

} )( jQuery );